function navegacaoOrigemDashboardEmpresa() {
  return queryParams.navigationOrigin === '1';
}

function navegacaoPaginaNoticia() {
  return window.location.href.includes('/noticia');
}

function constroiBreadcrumbNoticia() {
  if (navegacaoPaginaNoticia() && navegacaoOrigemDashboardEmpresa()) {
    construirBreadcrumb(['inicio', 'dashboard-empresa']);
  } else {
    construirBreadcrumb(['inicio']);
  }
}
